import React from "react";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { GET_APPEARANCES_BY_PLAYER_ID } from "../../GraphQL/Appearances.js";
import { GET_PLAYER } from "../../GraphQL/Players.js";
import LoadingSpinner from "../../Components/UI/LoadingSpinner.js";
import PageError from "../../Components/UI/PageError.js";
import PageLayout from "../../Components/UI/PageLayout.js";
import AppearanceTable from "../../Components/Appearance/AppearanceTable.js";
import TeamButton from "../../Components/Team/TeamButton.js";
import ManagerButton from "../../Components/Manager/ManagerButton.js";
import PlayerOverview from "../../Components/Player/PlayerOverview";
import UserButton from "../../Components/User/UserButton.js";
import { Typography } from "@mui/material";

const PlayerPage = () => {
  const { playerId } = useParams();

  const player = useQuery(GET_PLAYER, {
    variables: { id: playerId },
  });

  const appearances = useQuery(GET_APPEARANCES_BY_PLAYER_ID, {
    variables: { id: playerId },
  });

  const queryError = player.error || appearances.error;
  if (queryError) {
    return (
      <PageError
        message={queryError.message}
        onRetry={() => {
          player.refetch();
          appearances.refetch();
        }}
      />
    );
  }

  if (appearances.loading || player.loading) return <LoadingSpinner />;

  const breadcrumbs = player.data.player.team
    ? [
        { label: "Home", to: "/" },
        { label: "Teams", to: "/teams" },
        {
          label: player.data.player.team.name,
          to: "/team/" + player.data.player.team.id,
        },
        { label: player.data.player.name },
      ]
    : [{ label: "Home", to: "/" }, { label: player.data.player.name }];

  return (
    <PageLayout title={player.data.player.name} breadcrumbs={breadcrumbs}>
      <PlayerOverview player={player.data.player} />
      {player.data.player.team && (
        <TeamButton team={player.data.player.team} />
      )}
      {player.data.player.team?.manager && (
        <ManagerButton managerId={player.data.player.team.manager.id} />
      )}
      <UserButton userId={player.data.player.user.id} />
      <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>Appearances</Typography>
      <AppearanceTable
        appearancesWithPermission={[]}
        appearances={appearances.data.appearancesByPlayerId}
      />
    </PageLayout>
  );
};

export default PlayerPage;
